import {
  API_CURRENCY_SPREAD,
  API_CURRENCY_SPREAD_TYPES,
  API_TOPUP_AGENT_LIST,
  API_TOPUP_CARD_LIST,
  API_TOPUP_CREATE,
  API_TOPUP_CREATE_ADMIN,
  API_TOPUP_GET_BANKS,
  API_TOPUP_GET_COUNTRY,
  API_TOPUP_IBAN_CREATE,
  API_TOPUP_IBAN_DELETE,
  API_TOPUP_IBAN_LIST,
  API_TOPUP_LIST,
} from "./apiPaths";
import axiosMiddleware from "./axiosMiddleware";

export const topupUserAPI = ({
  walletId,
  userId,
  amount,
  description,
  fee,
  file,
}) => {
  let postData = {
    walletId,
    userId,
    amount,
    description,
    file,
  };
  return axiosMiddleware({
    method: "post",
    url: API_TOPUP_CREATE,
    data: postData,
  });
};

export const topupAdminAPI = ({
  walletId,
  adminId,
  amount,
  description,
  fee,
  file,
}) => {
  let postData = {
    wallet_id: walletId,
    admin_id: adminId,
    amount,
    description,
    file,
  };
  return axiosMiddleware({
    method: "post",
    url: API_TOPUP_CREATE_ADMIN,
    data: postData,
  });
};

export const getTopUpListAPI = ({
  limit,
  offset,
  from,
  to,
  agent,
  currency,
}) => {
  let url = `${API_TOPUP_LIST}?limit=${limit}&offset=${offset}`;

  if (agent !== 0) {
    url += `&agentId=${agent}`;
  }
  if (currency !== 0) {
    url += `&currencyId=${currency}`;
  }

  url += `&from=${from}&to=${to}`;

  return axiosMiddleware({
    method: "get",
    url: url,
  });
};

export const getTopUpCardListAPI = ({
  limit,
  offset,
  from,
  to,
  agent,
  currency,
}) => {
  let url = `${API_TOPUP_LIST}?limit=${limit}&offset=${offset}`;

  if (agent !== 0) {
    url += `&agentId=${agent}`;
  }
  if (currency !== 0) {
    url += `&currencyId=${currency}`;
  }

  url += `&from=${from}&to=${to}`;
  return axiosMiddleware({
    method: "get",
    url: url,
  });
};

export const getAllTopUpListAPI = (agent, currency, from, to) => {
  from = from.format("YYYY-MM-DD");
  to = to.format("YYYY-MM-DD");
  let url = API_TOPUP_LIST;
  url += `?agentId=${agent}&currencyId=${currency}&from=${from}&to=${to}`;
  console.log(url);
  return axiosMiddleware({
    method: "get",
    url: url,
  });
};

export const getAllTopUpCardListAPI = (agent, currency, from, to) => {
  from = from.format("YYYY-MM-DD");
  to = to.format("YYYY-MM-DD");
  let url = API_TOPUP_CARD_LIST;
  url += `?agentId=${agent}&currencyId=${currency}&from=${from}&to=${to}`;
  return axiosMiddleware({
    method: "get",
    url: url,
  });
};

export const getAgentTopUpListAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: API_TOPUP_AGENT_LIST,
  });
};

export const getTopUpCountriesAPI = ({ walletId }) => {
  return axiosMiddleware({
    method: "get",
    url: `${API_TOPUP_GET_COUNTRY}?currencyId=${walletId}`,
  });
};
export const getTopUpBanksAPI = ({ countryId }) => {
  return axiosMiddleware({
    method: "get",
    url: `${API_TOPUP_GET_BANKS}?countryId=${countryId}`,
  });
};
export const createTopUpIbanAPI = ({
  currencyId,
  countryName,
  bankName,
  iban,
  holderName,
}) => {
  let postData = {
    currencyId,
    countryName,
    bankName,
    iban,
    holderName,
  };
  return axiosMiddleware({
    method: "post",
    url: API_TOPUP_IBAN_CREATE,
    data: postData,
  });
};
export const getTopUpIbanListAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: API_TOPUP_IBAN_LIST,
  });
};
export const deleteTopUpIbanAPI = ({ id }) => {
  let deleteData = {
    id,
  };
  return axiosMiddleware({
    method: "delete",
    url: API_TOPUP_IBAN_DELETE,
    data: deleteData,
  });
};
export const editCurrencySpreadAPI = ({ currencyId, type, spread }) => {
  let postData = {
    currency_id: currencyId,
    type,
    spread,
  };
  return axiosMiddleware({
    method: "post",
    url: API_CURRENCY_SPREAD,
    data: postData,
  });
};
export const getCurrencySpreadTypesAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: API_CURRENCY_SPREAD_TYPES,
  });
};
